import { render } from "./CombineOrdersModal.vue?vue&type=template&id=1f8abe0e&scoped=true"
import script from "./CombineOrdersModal.vue?vue&type=script&lang=js"
export * from "./CombineOrdersModal.vue?vue&type=script&lang=js"

import "./CombineOrdersModal.vue?vue&type=style&index=0&id=1f8abe0e&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8abe0e"]])

export default __exports__